import React, { FunctionComponent } from 'react';
import { RadioComponentProps } from './RadioComponent.types';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';

export const RadioComponent: FunctionComponent<RadioComponentProps> = props => {
  const {
    className,
    checked,
    color = 'primary',
    disabled = false,
    id,
    label,
    name,
    onChange,
    required = false,
    size = 'medium',
    value,
  } = props;
  if (label) {
    return (
      <FormControlLabel
        control={
          <Radio
            checked={checked}
            className={className}
            color={color}
            disabled={disabled}
            id={id}
            name={name}
            onChange={onChange}
            required={required}
            size={size}
            value={value}
          />
        }
        labelPlacement={label.placement || 'end'}
        label={label.node}
      />
    );
  }
  return (
    <Radio
      checked={checked}
      className={className}
      color={color}
      disabled={disabled}
      id={id}
      name={name}
      onChange={onChange}
      required={required}
      size={size}
      value={value}
    />
  );
};
